import React from "react";
import PicMD from "../../components/PicMD";

const Moe = () => {
  return (
    <div>
      <PicMD doctor="Moe" />
      <strong>Meet Dr. Win Win Moe</strong>
      <br />
      <br />
      <p>
        Dr. Win Win Moe is a dedicated nephrologist whose global journey in medicine is defined by 
        a deep commitment to compassionate, multidisciplinary care for patients facing complex renal diseases.
      </p>
      <p>
        Her medical career began in Myanmar, where she graduated from University of Medicine, Yangon.
        Seeking to expand her clinical expertise, she moved to the United States and completed her internal
        medicine residency training at Rutgers Robert Wood Johnson Medical School (Jersey City) in 2016.
        During her residency, she developed a strong clinical interest in the intricate complexities of
        kidney physiology, complex electrolyte management, and the nuances of glomerular diseases.
        To specialize further in these fields, she pursued a comprehensive nephrology fellowship
        at NYU Long Island Hospital in 2019. Following her specialized training, she 
        relocated to the Pacific, spending three years in private practice in Hawaii,
        where she managed diverse patient populations with acute and chronic kidney conditions.
      </p>
      <p>
        In June 2026, she joined Advanced Kidney Care of Central Florida and she strongly
        believes that managing complex, chronic illnesses requires more than just clinical
        intervention; it demands empathy and collaboration. She champions a patient-centered
        philosophy, working hand-in-hand with a multidisciplinary team—including primary
        care physicians, dietitians, and care coordinators—to deliver seamless, high-quality,
        and compassionate care to every individual she treats.
      </p>
      <br />
    </div>
  );
};

export default Moe;
